import { NavigateFunction } from 'react-router';
import { HomePagesRoutes, LoginRoot, UserRoutes } from 'src/backoffice-app-code/routes/Routes';

export interface User {
  id: string;
  partnerId: string;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  userRole: UserRole;
  authId: string;
  createdAt: string;
}

export enum UserRole {
  PlatformAdmin = 'PLATFORM_ADMIN',
  EndUser = 'END_USER',
  InsuranceUnderwriter = 'INSURANCE_UNDERWRITER',
  InsuranceAdmin = 'INSURANCE_ADMIN',
  InsuranceAgent = 'INSURANCE_AGENT',
  ProductApprovalOperator = 'PRODUCT_APPROVAL_OPERATOR',
  ContentEditor = 'CONTENT_EDITOR',
  DistributorPartnerAdmin = 'DISTRIBUTOR_ADMIN',
  RetailerPartnerAdmin = 'RETAILER_ADMIN',
}

export const UserRoleLabels = {
  [UserRole.PlatformAdmin]: 'Platform Admin',
  [UserRole.EndUser]: 'End User',
  [UserRole.InsuranceUnderwriter]: 'Insurance Underwriter',
  [UserRole.InsuranceAdmin]: 'Insurance Admin',
  [UserRole.InsuranceAgent]: 'Insurance Agent',
  [UserRole.ProductApprovalOperator]: 'Product Approval',
  [UserRole.ContentEditor]: 'Content Editor',
  [UserRole.DistributorPartnerAdmin]: 'Distributor Partner',
  [UserRole.RetailerPartnerAdmin]: 'Retailer Partner',
};

export const getUserFullName = (user: User) => `${user.firstName} ${user.lastName}`;

export const navigateUserToProfile = (user: User | undefined, navigate: NavigateFunction) => {
  if (!user) return;
  if (user.userRole === UserRole.ContentEditor) {
    navigate(UserRoutes.commonProfile);
  } else if (user.userRole === UserRole.DistributorPartnerAdmin) {
    navigate(UserRoutes.commonProfile);
  } else if (user.userRole === UserRole.RetailerPartnerAdmin) {
    navigate(UserRoutes.commonProfile);
  } else if (user.userRole === UserRole.PlatformAdmin) {
    navigate(UserRoutes.commonProfile);
  } else if (user.userRole === UserRole.ProductApprovalOperator) {
    navigate(UserRoutes.commonProfile);
  } else if (user.userRole === UserRole.InsuranceUnderwriter) {
    navigate(UserRoutes.commonProfile);
  } else if (user.userRole === UserRole.InsuranceAgent) {
    navigate(UserRoutes.commonProfile);
  } else if (user.userRole === UserRole.InsuranceAdmin) {
    navigate(UserRoutes.commonProfile);
  }
};

export const getUserHomeRoute = (user: User | undefined): string => {
  if (!user) return LoginRoot;
  if (user.userRole === UserRole.ContentEditor) {
    return HomePagesRoutes.contentEditorHomePage;
  } else if (user.userRole === UserRole.DistributorPartnerAdmin) {
    return HomePagesRoutes.distributorHomePage;
  } else if (user.userRole === UserRole.RetailerPartnerAdmin) {
    return HomePagesRoutes.retailerHomePage;
  } else if (user.userRole === UserRole.PlatformAdmin) {
    return HomePagesRoutes.platformAdminHomePage;
  } else if (user.userRole === UserRole.ProductApprovalOperator) {
    return HomePagesRoutes.productApprovalOperaterHomePage;
  } else if (user.userRole === UserRole.InsuranceUnderwriter) {
    return HomePagesRoutes.platformAdminHomePage;
  } else if (user.userRole === UserRole.InsuranceAgent) {
    return HomePagesRoutes.insuranceAgentHomePage;
  } else if (user.userRole === UserRole.InsuranceAdmin) {
    return HomePagesRoutes.platformAdminHomePage;
  }

  return LoginRoot;
};
